var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:twitter-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7029 4.42909C19.0071 4.73742 18.2596 4.94576 17.4738 5.03992C18.2846 4.55475 18.8912 3.79115 19.1804 2.89159C18.4186 3.34408 17.5849 3.66259 16.7154 3.83326C16.1307 3.20898 15.3563 2.7952 14.5124 2.65615C13.6684 2.51711 12.8022 2.66058 12.0481 3.0643C11.2941 3.46802 10.6944 4.10939 10.3422 4.88884C9.99003 5.6683 9.90503 6.54222 10.1004 7.37492C8.55682 7.29742 7.04677 6.89621 5.66827 6.19734C4.28977 5.49847 3.07362 4.51756 2.09875 3.31826C1.76542 3.89326 1.57375 4.55992 1.57375 5.26992C1.57338 5.90909 1.73078 6.53846 2.03198 7.1022C2.33319 7.66594 2.76888 8.14662 3.30042 8.50159C2.68398 8.48198 2.08114 8.31541 1.54208 8.01576V8.06576C1.54202 8.96221 1.85211 9.83107 2.41974 10.5249C2.98736 11.2188 3.77756 11.6949 4.65625 11.8724C4.0844 12.0272 3.48486 12.05 2.90292 11.9391C3.15083 12.7104 3.63375 13.3849 4.28406 13.8682C4.93437 14.3514 5.71951 14.6192 6.52958 14.6341C5.15444 15.7136 3.45616 16.2992 1.70792 16.2966C1.39823 16.2967 1.08881 16.2786 0.78125 16.2424C2.55581 17.3834 4.62153 17.9889 6.73125 17.9866C13.8729 17.9866 17.7771 12.0716 17.7771 6.94159C17.7771 6.77492 17.7729 6.60659 17.7654 6.43992C18.5248 5.89074 19.1803 5.21067 19.7013 4.43159L19.7029 4.42909Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterWhite);
export default __webpack_public_path__ + "static/media/twitter-white.e75ae14456a5b6a909f1ea9b3203b21b.svg";
export { ForwardRef as ReactComponent };